import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-ricorso-al-tar-view',
  templateUrl: './form-ricorso-al-tar-view.component.html',
  styleUrls: ['./form-ricorso-al-tar-view.component.css']
})
export class FormRicorsoAlTarViewComponent {

  @Input() ctxBodyFascicolo;
  constructor() {}
}
